import { createBrowserRouter, RouteObject } from "react-router-dom";
import { App } from "src/App";
import { RouteEnvironmentProviders } from "src/routing/components/RouteEnvironment";
import { adminRoutes } from "src/routing/domains/admin";
import { bidPackagesRoutes } from "src/routing/domains/bidPackages";
import { changeLogRoutes } from "src/routing/domains/changeLog";
import { financesRoutes } from "src/routing/domains/finances";
import { librariesRoutes } from "src/routing/domains/libraries";
import { projectsDevelopmentsRoutes } from "src/routing/domains/projects";
import { tradePartnersRoutes } from "src/routing/domains/tradePartners";
import { warrantyRoutes } from "src/routing/domains/warranty";

/**
 * Composition root for `RouterProvider` (`src/index.tsx`).
 *
 * Role: data router entry. See `src/routing/README.md` for the full boundary diagram.
 *
 * ┌─ migratedRoutes[]     URLs matched here use `AppShell` + domain route trees in `src/routing/domains/*.ts`
 * └─ legacyCatchAllRoute   All other URLs fall through to legacy `App` → `Routes.tsx`
 */

/** Domains migrated off `Routes.tsx`. Register new `RouteObject`s here, above the legacy catch-all. */
const migratedRoutes: RouteObject[] = [
  ...librariesRoutes,
  ...projectsDevelopmentsRoutes,
  ...tradePartnersRoutes,
  ...bidPackagesRoutes,
  ...financesRoutes,
  ...changeLogRoutes,
  ...warrantyRoutes,
  ...adminRoutes,
];

/**
 * Catch-all for URLs not matched by `migratedRoutes`.
 *
 * Role: legacy routing. Unmatched paths enter `src/App.tsx` → `PageLayout` / `PdfLayout` → `src/Routes.tsx`.
 */
const legacyCatchAllRoute: RouteObject = {
  path: "*",
  element: (
    <RouteEnvironmentProviders>
      <App />
    </RouteEnvironmentProviders>
  ),
};

export const appRoutes = [...migratedRoutes, legacyCatchAllRoute];

export const router = createBrowserRouter(appRoutes);
